import { pageViewBuilderSchema, type PageViewBuilderSchema } from '@app/schemas/builder';
import { builderHasServiceRequest } from './builder-runtime';

/** A malformed builder page must not stop rendering existing page types. */
export function parseBuilderPage(value: unknown): PageViewBuilderSchema | undefined {
  try {
    const result = pageViewBuilderSchema.safeParse(value);
    return result.success ? result.data : undefined;
  }
  catch {
    return undefined;
  }
}

export function pageHasServiceRequest(page: { view: unknown }): boolean {
  if (!page.view || typeof page.view !== 'object' || !('type' in page.view)) {
    return false;
  }

  if (page.view.type === 'service-centre.v1') {
    return true;
  }

  if (page.view.type !== 'builder.v1') {
    return false;
  }

  const view = parseBuilderPage(page.view);
  return !!view && builderHasServiceRequest(view.root);
}
